module.exports = __webpack_public_path__ + "static/khorshidnet-cover-e70fd51e80336347aa339c71e68afcf8.jpg";